export default "__VITE_ASSET__d283fed4__"